// extracted by mini-css-extract-plugin
export default {"form":"NovoUsuario_form__06TId","areaBtn":"NovoUsuario_areaBtn__z2YYZ","btn":"NovoUsuario_btn__h8Iig"};